import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DashboardReports } from '../../../../../screens/report-dashboard/component/DashboardReports';
import styles from './DashboardScreenForZoom.module.css';

const DashboardScreenForZoom = () => {
  const navigate = useNavigate();
  const params = useParams<{ livePollId: string; livePollSessionId: string }>();
  const livePollId = +params.livePollId!;
  const livePollSessionId = +params.livePollSessionId!;

  const onButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className={styles.container}>
      <DashboardReports
        livePollId={livePollId}
        livePollSessionId={livePollSessionId}
        onBackButtonClick={onButtonClick}
      />
    </div>
  );
};

export default DashboardScreenForZoom;
